import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-form";
import { map } from "lodash";
import moment from "moment";
import ReactPaginate from "react-paginate";
import TextFields from "../UI/TextFiled";
import DatePickerUI from "../UI/DatePicker";
import {
  getFinanceRestaurants,
  getSearchFinanceRestaurants,
  downloadFinanceRestaurants
} from "../../store/actions/financeRestaurants";
import { connect } from "react-redux";

class Restaurants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: "",
      dateTo: "",
      searchValue: "",
      currentPage: 1,
      restauranseLength: 0
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.dateFrom = this.dateFrom.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }

  async componentDidMount() {
    await this.props.getFinanceRestaurants(this.props.auth.token, 1);
    let restauransesReportShow = [];
    map(this.props.financeRestaurant.results, data => {
      restauransesReportShow.push(data);
    });
    if (this.state.restauranseLength <= restauransesReportShow.length) {
      this.setState({ restauranseLength: restauransesReportShow.length });
    }
  }
  handleClick(pagenumber) {
    this.props.getFinanceRestaurants(
      this.props.auth.token,
      pagenumber.selected + 1
    );
  }
  handleInput(e) {
    this.setState({ searchValue: e.target.value });
  }
  onSearch() {
    this.props.getSearchFinanceRestaurants(
      this.props.auth.token,
      this.state.dateFrom,
      this.state.dateTo,
      this.state.searchValue
    );
  }
  async dateFrom(lag, date) {
    if (lag === "From") {
      await this.setState({
        dateFrom: moment(date).format("YYYY-MM-DD")
      });
    } else if (lag === "To") {
      await this.setState({
        dateTo: moment(date).format("YYYY-MM-DD")
      });
    }
    this.props.getSearchFinanceRestaurants(
      this.props.auth.token,
      this.state.dateFrom,
      this.state.dateTo,
      this.state.searchValue
    );
  }
  async onDownload() {
    const response = await this.props.downloadFinanceRestaurants(
      this.props.auth.token,
      this.state.dateFrom,
      this.state.dateTo,
      this.state.searchValue
    );
    const url = window.URL.createObjectURL(new Blob([response.payload]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Finance_restaurants.csv");
    link.click();
  }
  render() {
    const restaurants = map(this.props.financeRestaurant.results, data => data);
    let currentsRestaurantsCount =
      this.state.restauranseLength > 0
        ? this.state.restauranseLength
        : restaurants.length;
    let pageCount = Math.ceil(
      this.props.financeRestaurant.count / currentsRestaurantsCount
    );

    return (
      <React.Fragment>
        <div className="page-title">
          <div className="container">
            <div className="row flex-center-y justify-between">
              <div className="col-xs-9">
                <h1 className="color-grey">Restaurants</h1>
              </div>
              <div className="col-xs-3">
                <Form>
                  {formApi => (
                    <form
                      onSubmit={formApi.submitForm}
                      className="search"
                      onChange={this.handleInput}
                    >
                      <TextFields type="text" hintText="Search" />
                      <button
                        className="no-style search-btn pointer"
                        onClick={this.onSearch}
                      >
                        <i className="fa fa-search" />
                      </button>
                    </form>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="container box py-15">
          <Form onSubmit={this.submitted}>
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="row">
                  <div className="col-xs-2">
                    <DatePickerUI
                      label="From"
                      hintText="From"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                  <div className="col-xs-2 ml-30">
                    <DatePickerUI
                      label="To"
                      hintText="To"
                      dateFrom={this.dateFrom}
                    />
                  </div>
                </div>
              </form>
            )}
          </Form>
          <div className="table mt-20">
            <table>
              <thead>
                <tr>
                  <th>Restaurant Name</th>
                  <th>Total Number of Orders</th>
                  <th>Billing Amount</th>
                  <th>Total Income</th>
                </tr>
              </thead>
              <tbody>
                {map(this.props.financeRestaurant.results, (row, i) => {
                  return (
                    <tr key={i}>
                      <td>{row.name}</td>
                      <td>{row.total_orders_count}</td>
                      <td>{row.billing_amount || 0} SAR</td>
                      <td>{row.foodna_income || 0}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {pageCount > 1 && (
            <ReactPaginate
              onPageChange={this.handleClick}
              pageCount={pageCount}
              initialPage={0}
              breakClassName={"break-me"}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
            />
          )}
          <div className="text-right mt-20" onClick={this.onDownload}>
            <Link to="#" className="flex-align-y font-sm w-800">
              <i className="fa fa-download mr-10" />
              Download Excel File
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    financeRestaurant: state.financeRestaurant,
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    getFinanceRestaurants,
    getSearchFinanceRestaurants,
    downloadFinanceRestaurants
  }
)(Restaurants);



// WEBPACK FOOTER //
// ./src/components/Finance/Restaurants.js